var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Dropdown, Menu } from 'antd';
import React, { useCallback } from 'react';
import { useWallet, useWalletModal } from '../../contexts/WalletContext';
export var ConnectButton = function (props) {
    var children = props.children, disabled = props.disabled, allowWalletChange = props.allowWalletChange, className = props.className, rest = __rest(props, ["children", "disabled", "allowWalletChange", "className"]);
    var _a = useWallet(), wallet = _a.wallet, connect = _a.connect, connected = _a.connected;
    var setVisible = useWalletModal().setVisible;
    var open = useCallback(function () { return setVisible(true); }, [setVisible]);
    var handleClick = useCallback(function () { return (wallet ? connect().catch(function () { }) : open()); }, [wallet, connect, open]);
    // only show if wallet selected or user connected
    if (!wallet || !allowWalletChange) {
        return (_jsx(Button, __assign({ className: className || 'connector' }, rest, { onClick: function (e) {
                props.onClick ? props.onClick(e) : null;
                handleClick();
            }, disabled: connected && disabled }, { children: children })));
    }
    return (_jsx(Dropdown.Button, __assign({ className: className || (connected ? 'connector' : ''), onClick: handleClick, disabled: connected && disabled, overlay: _jsx(Menu, __assign({ className: 'black-dropdown' }, { children: _jsx(Menu.Item, __assign({ onClick: open }, { children: "Change Wallet" })) })) }, { children: "Connect" })));
};
